import { CheckboxGroup } from '../CheckboxGroup/CheckboxGroup.js';
export { CheckboxGroup as RadioButtonGroup } from '../CheckboxGroup/CheckboxGroup.js';
import '../CheckboxGroup/ChecboxGroupContext.js';

// See CheckboxGroup for the implementation
CheckboxGroup.displayName = 'RadioButtonGroup';
//# sourceMappingURL=RadioButtonGroup.js.map
